import { render, staticRenderFns } from "./restaurant_work.vue?vue&type=template&id=6339767c&scoped=true&"
import script from "./restaurant_work.vue?vue&type=script&lang=js&"
export * from "./restaurant_work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6339767c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6339767c')) {
      api.createRecord('6339767c', component.options)
    } else {
      api.reload('6339767c', component.options)
    }
    module.hot.accept("./restaurant_work.vue?vue&type=template&id=6339767c&scoped=true&", function () {
      api.rerender('6339767c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/restaurant_work.vue"
export default component.exports